export default {"src":"/_next/static/media/left_arrow_blue.292c011d.svg","height":25,"width":16,"blurWidth":0,"blurHeight":0};